const Logo = ({ light = false, className = "" }) => (
  <div
    className={`flex flex-col items-center leading-none ${className}`}
    data-testid="brand-logo"
  >
    <img
      src={light ? "/assets/logo-light.png" : "/assets/logo-dark.png"}
      alt="RUS Srl"
      className="h-14 w-auto md:h-16"
    />
    <span
      className={`mt-2 translate-x-[0.25em] font-sans text-[11px] font-medium uppercase tracking-[0.5em] ${
        light ? "text-sand" : "text-bark"
      }`}
    >
      Parquet
    </span>
  </div>
);

export default Logo;
